module.exports = __webpack_public_path__ + "static/media/send-letter-info-img3.84cc665b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/send-letter-info-img3.png
// module id = 1315
// module chunks = 1